import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-09-13'
        tag='-'
        title='Create A Good Listing Title And Attract Your Audience Like A Pro'
      >
        <h3>Why is having a good listing title important in the marketplace?</h3>
        <p>
          Sellers get potential buyers to click and take notice of their listings by attracting them with good listings
          titles. This is important because the listings page or the search results provide the initial impression of
          you and your item. It also offers the primary search engine terms that shoppers can use to find your stuff.
        </p>
        <p>
          Even though it might seem obvious, having quality listing titles is a fact that is frequently ignored. Having
          noticeable titles for your listing allows customers to choose your product from among dozens or hundreds of
          rival products discovered through visual search, search tools, or category browsing.
        </p>

        <h3>Advantages of having a good listing title</h3>
        <p>
          As mentioned, a good listing title is critical in getting more customers to take notice of your online shop
          and what you have to offer. It helps boost sales to get more eyeballs to check out your listings and gets you
          to the top of the search engines by using quality keywords that your potential buyers are scouting the
          marketplace for.
        </p>
        <p>
          Therefore, having a good title improves your exposure and gives you a higher chance of coming across the right
          buyer looking to purchase a specific item. It's good for sales and directly impacts the potential buyer's
          overall buying experience.
        </p>

        <h3>Tips on creating a good listing title</h3>
        <p>
          When creating a good listing title, sellers should take note of when a buyer begins their purchasing journey;
          it always starts with a search and a listing. So having an attractive listing title is incredibly beneficial
          in boosting sales and improving your leads in any marketplace. Here are some tips when creating a listing
          title:
        </p>
        <ul>
          <li>Describe the product in clear, uncomplicated language.</li>
          <li>Mention specifics like size, color, gender, material, and condition.</li>
          <li>Include the brand name or the name of the producer or designer.</li>
          <li>Add the model name (if applicable)</li>
        </ul>
        <p>Don't worry about repeating the category name or parts of the description in the title.</p>

        <h3>Things to avoid when creating your listing title</h3>
        <p>
          Making mistakes in creating listing titles is no problem, and a good seller's rule to follow to create
          attractive and quality titles to attract buyer attention are the following:
        </p>
        <ul>
          <li>
            Eliminate typos! While most people can understand words that have been misspelled, most search engines and
            classification tools won't pick them up. So be sure to write in only one language, that of the marketplace
            you are using (e.g., English for eBay.com, French for eBay.fr, etc.). (e.g., English for eBay.com, French
            for eBay.fr, etc.). Having titles in many languages could classify your product incorrectly
          </li>
          <li>Do not use special characters or punctuation</li>
          <li>Avoid overusing acronyms. All humans and robots must be able to understand your title with ease</li>
          <li>
            Don't use language that would cause most marketplaces to ban your listing, such as profanity, providing
            email addresses or website addresses, or using other such words
          </li>
          <li>
            And most importantly, don't make untrue or deceptive statements. Do not use any brand names other than one
            of the products you are displaying; doing so is known as "keyword spamming" and is not permitted on any
            respectable website
          </li>
        </ul>

        <h3>Focus on what matters in your business and do more with automation</h3>
        <p>
          Do more with your business by streamlining your processes and listings to free up more time and be more
          efficient with your sales and customers. OneShop is a specially designed automation tool to help sellers do
          faster and more efficiently with just one dashboard.
        </p>
        <p>
          With OneShop, you can easily monitor and ensure that your descriptions are on par to be found on the top of
          the search engine and get more customers to take notice of your listings. You can also make more sales by
          cross-listing across Mercari, Poshmark, Depop, and eBay, more sites soon, and enjoy the auto delisting feature
          to help you avoid accidentally selling a single item to multiple buyers.
        </p>
        <p>
          These tools and features are a seller's secret weapon to make it easier for them to do tasks quickly. In
          addition, you can simply manage your seller objectives and rankings, schedule package pickups, order shipping
          supplies, print shipping labels from the app, and so much more!
        </p>
        <p>
          Give it a try now by signing up <a href='https://tools.oneshop.com/signup'>here</a>. Set up your account in
          less than three minutes, and enjoy a <>{Constants.Marketing.TrialDuration}</>-day free trial!
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
